<template>
    <div class="ion-thumbnail">
        <img  :src="src" alt="">
    </div>
</template>
<script>
    export default {
        name: 'ion-thumbnail',
        props: {
            src: {
                type: String,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// thumbnail.vue?2711a64e